import { useState, useEffect } from 'react';

// Danh sách ngân hàng VietQR là endpoint CÔNG KHAI (https://api.vietqr.io/v2/banks — không cần
// clientID/apiKey). Trước đây truyền creds hardcode trong bundle FE (SEC-8 leak) dù getBanks() không
// cần → gọi thẳng endpoint public, KHÔNG nhét credential nào vào FE.
const useVietQR = () => {
  const [banks, setBanks] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await fetch('https://api.vietqr.io/v2/banks');
        const json = await response.json();
        setBanks(json.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBanks();
  }, []);

  return { banks, loading, error };
};

export default useVietQR;
